import { render, staticRenderFns } from "./round-button.vue?vue&type=template&id=1a7f34d3&scoped=true"
import script from "./round-button.vue?vue&type=script&lang=js"
export * from "./round-button.vue?vue&type=script&lang=js"
import style0 from "./round-button.vue?vue&type=style&index=0&id=1a7f34d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f34d3",
  null
  
)

export default component.exports